export var SubstratePermissionScope;
(function (SubstratePermissionScope) {
    SubstratePermissionScope["transfer"] = "transfer";
    SubstratePermissionScope["sign_payload_json"] = "sign_payload_json";
    SubstratePermissionScope["sign_payload_raw"] = "sign_payload_raw";
})(SubstratePermissionScope || (SubstratePermissionScope = {}));
